import { Component, Fragment, ReactNode } from "react";
import SwiperCore, { Autoplay, EffectCoverflow, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// import { IconCloud } from "../../../shadcomponents/ui/icon-cloud";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "./InfiniteScroll.css";
import { SparklesText } from "../../../shadcomponents/ui/sparkles-text";
import { AnimatedShinyText } from "../../../shadcomponents/ui/animated-shiny-text";
// import { AnimatedListTinker, Tinker } from "../Tinker/Tinker";

/* const slugs = [
  "typescript",
  "angular",
  "react",
  "maui",
  "html5",
  "css3",
  "nodedotjs",
  "express",
  "nextdotjs",
  "svelte",
  "ruby",
  "csharp",
  "prisma",
  "amazonaws",
  "postgresql",
  "firebase",
  "nginx",
  "vercel",
  "digitalocean",
  "openai",
  "jest",
  "cypress",
  "docker",
  "git",
  "jira",
  "github",
  "gitlab",
  "visualstudiocode",
  "androidstudio",
  "sonarqube",
  "figma",
]; */

SwiperCore.use([Autoplay]);

class InfiniteScroll extends Component {
  render(): ReactNode {
    {
      /* const images = slugs.map(
      (slug) => `https://cdn.simpleicons.org/${slug}/${slug}`
    ); */
    }

    return (
      <Fragment>
        {/*<div className="absolute flex  items-center justify-center overflow-hidden rounded-lg xs:top-1/3 xs:left-1/2 xs:transform xs:-translate-x-1/2 xs:-translate-y-1/3  sm:top-28 lg:top-12 sm:left-auto sm:right-1 opacity-80 z-10">
          <IconCloud images={images} />
        </div> */}

        <div className="skewMain ">
          {/* <div className="ml-20">
            <AnimatedListTinker />
          </div>

        
          <div className="bg-text-container">
            <div className="animate-text-deux">
              <span className="dualScroll">Continuous education&nbsp;</span>
              <span className="dualScroll">Web Updates&nbsp;</span>
              <span className="dualScroll">
                Unlimited amount of energy&nbsp;
              </span>
            </div>
            <div className="animate-text-deux left">
              <span className="dualScroll">Continuous education&nbsp;</span>
              <span className="dualScroll">Web Updates&nbsp;</span>
              <span className="dualScroll">
                Unlimited amount of energy&nbsp;
              </span>
            </div>
          </div> */}

          <div className="container">
            <Swiper
              autoplay={{ delay: 10000, disableOnInteraction: false }}
              effect={"fade"}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={1}
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              loop={true}
              pagination={true}
              modules={[EffectCoverflow, Pagination]}
              className="mySwiper trioblog "
            >
              <SwiperSlide>
                <a
                  href="https://blog.ajov.dev/post/ollama-n8n-rag-v2-split-embed-response-2026"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="col">
                    <SparklesText text="Ollama with FastAPI and N8N V2: Splitting Embed and Response  " />
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-cyan-500 text-white rounded">
                      Blog
                    </span>
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-blue-600 text-white rounded">
                      Feb 2026
                    </span>
                    <p className="text-xs md:text-lg">
                      This second version separates the requests:{" "}
                      <AnimatedShinyText>/embed</AnimatedShinyText> for
                      embedding and <AnimatedShinyText>/ask</AnimatedShinyText>{" "}
                      for response.
                    </p>
                  </div>
                </a>
              </SwiperSlide>
              <SwiperSlide>
                <a
                  href="hhttps://blog.ajov.dev/post/rushed-management-code-quality-10-ways-2025"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="col">
                    <SparklesText text="Rushed Leadership Choices That Destroy Code Quality (10 Ways) " />
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-cyan-500 text-white rounded">
                      Blog
                    </span>
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-blue-600 text-white rounded">
                      Nov 2025
                    </span>
                    <p className="text-xs md:text-lg">
                      When software quality drops, it’s easy to blame the
                      developers ... 10 ways rushed{" "}
                      <AnimatedShinyText> leadership </AnimatedShinyText>
                      decisions damage code quality, and what better management
                      looks like.
                    </p>
                  </div>
                </a>
              </SwiperSlide>
              <SwiperSlide>
                <a
                  href="https://blog.ajov.dev/post/ollama-n8n-fastapi-single-request-2025"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="col">
                    <SparklesText text="Ollama with FastAPI and N8N" />
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-cyan-500 text-white rounded">
                      Blog
                    </span>
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-blue-600 text-white rounded">
                      Aug 2025
                    </span>
                    <p className="text-xs md:text-lg">
                      This Blog demonstrates how to integrate{" "}
                      <AnimatedShinyText>Ollama with FastAPI</AnimatedShinyText>{" "}
                      and a{" "}
                      <AnimatedShinyText>self-hosted n8n</AnimatedShinyText>{" "}
                      workflow , enabling AI-powered question answering based on
                      data scraped from Shopify documentation
                    </p>
                  </div>
                </a>
              </SwiperSlide>
              <SwiperSlide>
                <a
                  href="https://blog.ajov.dev/post/cat-dog-classification-with-pocket-flow-tutorial-2025"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="col">
                    <SparklesText text="PocketFlow Tutorial Codebase Knowledge" />
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-cyan-500 text-white rounded">
                      Blog
                    </span>
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-blue-600 text-white rounded">
                      Jul 2025
                    </span>
                    <p className="text-xs md:text-lg">
                      Originally built in 2022, I have{" "}
                      <AnimatedShinyText>
                        Cat-Dog Classification TFLite Flutter project
                      </AnimatedShinyText>{" "}
                      served as an experiment in mobile machine learning. This
                      project was recently revisited to evaluate how{" "}
                      <AnimatedShinyText>
                        PocketFlow-Tutorial-Codebase-Knowledge
                      </AnimatedShinyText>{" "}
                      can assist in documenting and explaining the workflow more
                      effectively.
                    </p>
                  </div>
                </a>
              </SwiperSlide>
              <SwiperSlide>
                <a
                  href="https://blog.ajov.dev/post/shopify-webpixel-extension-guide-2025"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="col">
                    <SparklesText text=" Shopify Web Pixel Extension" />
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-cyan-500 text-white rounded">
                      Blog
                    </span>
                    <span className="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-blue-600 text-white rounded">
                      Feb 2025
                    </span>
                    <p className="text-xs md:text-lg">
                      Creating a Shopify Web Pixel within a custom app is fairly
                      straightforward - app using{" "}
                      <AnimatedShinyText>Remix and Polaris</AnimatedShinyText>,
                      but there are a few steps that can trip you up during the
                      setup.
                    </p>
                  </div>
                </a>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default InfiniteScroll;
